const fields = (t) => ({
    config: {columns: 1},
    fields: [
        {
            name: "cartonDimensions",
            label: t ? t("forms.carton_dimensions") : "Wymiary kartonika (mm)",
            column: 1,
            type: "text"
        },
        {
            name: "cartonType",
            label: t ? t("forms.carton_type") : "Typ kartonika",
            column: 1,
            type: "text"
        },
        {
            name: "leafletSize",
            label: t ? t("forms.leaflet_size") : "Wymiar ulotki",
            column: 1,
            type: "text"
        },
        {
            name: "foldingType",
            label: t ? t("forms.folding_type") : "Rodzaj składania",
            column: 1,
            type: "text"
        },
        {
            name: "blisterCountInCarton",
            label: t ? t("forms.blisters_count_in_carton") : "Liczba blistrów w kartoniku",
            column: 1,
            type: "text"
        },
        {
            name: "cartonMarking",
            label: t ? t("forms.carton_marking") : "Oznakowanie kartonika",
            column: 1,
            type: "text"
        }
    ]
});

export default fields;
